import { render, staticRenderFns } from "./SceneLink.vue?vue&type=template&id=4c5d546a&scoped=true&"
import script from "./SceneLink.vue?vue&type=script&lang=js&"
export * from "./SceneLink.vue?vue&type=script&lang=js&"
import style0 from "./SceneLink.vue?vue&type=style&index=0&id=4c5d546a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d546a",
  null
  
)

export default component.exports